module.exports = __webpack_public_path__ + "img/elog.754a1eb6.png";